import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Switch,
    Divider,
    Box,
} from '@mui/material';
import {
    Notifications,
    Language,
    DarkMode,
    Security,
} from '@mui/icons-material';

const SettingsPage = () => {
    const [settings, setSettings] = useState({
        notifications: true,
        darkMode: true,
        twoFactor: false,
    });

    const handleToggle = (key) => {
        setSettings({ ...settings, [key]: !settings[key] });
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                الإعدادات
            </Typography>

            <Card>
                <CardContent>
                    <List>
                        <ListItem>
                            <Box sx={{ mr: 2 }}><Notifications color="primary" /></Box>
                            <ListItemText
                                primary="الإشعارات"
                                secondary="تفعيل الإشعارات للتنبيهات المهمة"
                            />
                            <ListItemSecondaryAction>
                                <Switch
                                    edge="end"
                                    checked={settings.notifications}
                                    onChange={() => handleToggle('notifications')}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider variant="inset" component="li" />

                        <ListItem>
                            <Box sx={{ mr: 2 }}><DarkMode color="primary" /></Box>
                            <ListItemText
                                primary="الوضع الليلي"
                                secondary="استخدام الثيم الداكن للتطبيق"
                            />
                            <ListItemSecondaryAction>
                                <Switch
                                    edge="end"
                                    checked={settings.darkMode}
                                    onChange={() => handleToggle('darkMode')}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider variant="inset" component="li" />

                        <ListItem>
                            <Box sx={{ mr: 2 }}><Security color="primary" /></Box>
                            <ListItemText
                                primary="المصادقة الثنائية"
                                secondary="تأمين الحساب باستخدام 2FA"
                            />
                            <ListItemSecondaryAction>
                                <Switch
                                    edge="end"
                                    checked={settings.twoFactor}
                                    onChange={() => handleToggle('twoFactor')}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        </Container>
    );
};

export default SettingsPage;
